import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  waiting: "bg-[hsl(40_20%_88%)] text-[hsl(20_10%_35%)] border-transparent",
  generating: "bg-[hsl(35_60%_88%)] text-[hsl(30_60%_30%)] border-transparent animate-pulse",
  regenerating: "bg-[hsl(35_60%_88%)] text-[hsl(30_60%_30%)] border-transparent animate-pulse",
  generated: "bg-[hsl(150_25%_86%)] text-[hsl(150_35%_25%)] border-transparent",
  reviewing: "bg-[hsl(200_30%_87%)] text-[hsl(200_40%_28%)] border-transparent",
  approved: "bg-[hsl(150_40%_35%)] text-white border-transparent",
  failed: "bg-[hsl(0_60%_90%)] text-[hsl(0_60%_38%)] border-transparent",
};

const LABELS = {
  waiting: "Waiting",
  generating: "Generating",
  regenerating: "Regenerating",
  generated: "Generated",
  reviewing: "Reviewing",
  approved: "Approved",
  failed: "Failed",
};

export function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.waiting;
  return (
    <Badge
      data-testid={`status-badge-${status}`}
      className={`rounded-sm px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider ${style} ${className}`}
    >
      {LABELS[status] || status}
    </Badge>
  );
}
